export default __webpack_public_path__ + "static/media/palette.4c9afcb4.svg";